module.exports = __webpack_public_path__ + "static/media/cart-arrow-down.55aa361f.svg";